import styled from 'styled-components'
import { Loader } from 'semantic-ui-react'

export const LoadingIcon = styled(Loader)`
  float: right;
  margin-top: -2.3em !important;
  margin-right: 1em !important;
  pointer-events: none;
`
